<template lang="pug">
.pb-1
  v-divider(v-if='hideCardEdges')
  v-card(v-if='userHasCustomFieldsSharingFF()' :class='cardClass')
    v-container.pa-2
      v-layout
        v-flex(sm9, md10, lg10, xl10)
          v-layout(row, align-start)
            .icon-container.mr-3
              v-icon.icon(:class='activityClass') {{ activityIcon }}
            v-flex(sm10, md12, lg12, xl12)
              v-menu(
                ref="sender-info-menu"
                :close-on-content-click="false"
                :open-on-hover="true"
                :disabled="!isEmailSentActivity || !hasValidEmailSenderInfo"
                content-class="email-sent-info-menu"
                transition="scale-transition"
                bottom
                lazy
                offset-y
              )
                span.activity-title(slot="activator") {{ activityTitle() }}
                v-card(v-if="hasValidEmailSenderInfo").pa-2
                  div 
                    strong {{ sentFromDetail }}
                  div 
                    strong Email: 
                    span {{ activity.user_email }}
              span.text-style.wrap-words(v-if='activity.user') - {{ activityTitleUserName() }}
                template(v-if='activity.type === callRecordingType')
                  span(v-if='!isRecordingLoaded(activity.description)') Click to play recording
                  v-btn.primary.play-recording(
                    v-if='!isRecordingLoaded(activity.description)',
                    small,
                    fab,
                    @click='getRecording({ recordingId: activity.description })'
                  )
                    v-icon play_arrow
                  audio.call-recording(
                    v-if='isRecordingLoaded(activity.description)',
                    controls
                  )
                    source(:src='loadedRecording.blobUrl', type='audio/mpeg')
                v-layout(column)
                  span.text-style(v-html= 'activitySubtitleByType()')
                  v-divider.mb-2(v-if="isSMSNotDeliveredNoRegType()")
                  div.text-style.show-white-spaces(v-if='checkActivityPropertyAndType()' v-html='safePlainText(activityDescriptionByType(), maxDescriptionLength)')
                  div.show-white-spaces(v-if="isCommentActivity && isCommentSection" v-html="safeHTML(activityDescriptionByType())")
                  div(v-if='isSMSNotDeliveredType()') 
                    div.red--text Error 30007 - The receiving carrier rejected the message, try changing the wording of the text or removing any hyperlinks.
                    a(href="https://lonewolf.my.site.com/s/article/LD-Failed-texts-due-to-message-filtering-and-carrier-filtering-LionDesk" target="_blank") 
                      | Learn more about this error
                  div(v-if='isSMSMobilePhoneInvalidType()') 
                    div.red--text Unable to send SMS. Recipient number is not a valid mobile number.
                  div(v-if='isLoneWolfTransaction()') 
                    p.mb-0.text-style {{ transactionCreatedText }}
                    a(:href='activity.description', target='_blank')
                      span.text-style.font-weight-bold.primary--text View or edit this transaction
                        v-icon.ml-2.open-link-icon.font-weight-bold.primary--text open_in_new
                  div(v-if='isContactOwnerChanged()')
                    p.mb-0.text-style {{ contactOwnerChangedDescription.description }}
                  div(v-if='isCmaActivity')
                    div(v-if='checkCloudCMAStatus("pending")')
                      p.mb-0.text-style Your CMA is still being prepared. Wait a minute and refresh this page. If no document appears click
                        a.font-weight-bold(
                          :href='this.cloudCMADescription.cmaURL',
                          target='_blank'
                        ) here
                        |
                        | to log in and manually publish the CMA.
                    div(v-if='checkCloudCMAStatus("failed")')
                      p.mb-0.text-style The Cloud CMA for
                        span.ml-1 {{ this.cloudCMADescription.address }}
                        | could not be created, plese head over to Cloud CMA and review the information given.
                      a(:href='this.cloudCMADescription.editPdf', target='_blank')
                        span.text-style.font-weight-bold.primary--text
                          | Edit Cloud CMA
                    div(v-if='checkCloudCMAStatus("success")')
                      p.mb-0.text-style Cloud CMA was created for
                        span.ml-1 {{ this.cloudCMADescription.address }}
                      div
                        button.mr-2(@click='copyPdfURL()')
                          span.text-style.font-weight-bold.primary--text
                            | Copy PDF Url
                        a.ml-2(:href='this.cloudCMADescription.documentPDF', target='_blank')
                          span.text-style.font-weight-bold.primary--text
                            | View CMA report
                        button.ml-2(@click="$emit('open-email-drawer')")
                          span.text-style.font-weight-bold.primary--text
                            | Email CMA report
                    v-snackbar(:value='copyPDFStatus', :color='copyPDFStatusColor')
                      .snackbar-msg {{ copyPDFMsg }}
                template(v-if='activity.property && activity.property.length > 0')
                  .mt-1
                    p.property-field.--v-secondary-lighten2.text-style MLS:
                      span.property-value.text-style {{ activity.property[0].mls }}
                    p.property-field.--v-secondary-lighten2.text-style Address:
                      span.property-value.text-style {{ activity.property[0].address }}
                    p.property-field.--v-secondary-lighten2.text-style Property Url:
                      a(:href='activity.property[0].url', target='_blank') View
        v-flex(sm3, md3, lg2, xl2)
          v-layout(column, align-end)
            span.date {{ activity.created_at | formatDateMonthDayYearExtended }}
            v-flex
              v-layout(row)
                v-btn.ma-0.action-btn.px-1(
                  v-if="isCommentActivity"
                  data-cy='edit-comment',
                  icon,
                  :disabled='user.id !== activity.user_id'
                  @click="editEvent(activity)"
                )
                  v-icon.icon-action edit
                v-flex
                  v-btn.ma-0.action-btn.px-1(
                    icon,
                    v-if="isCommentActivity",
                    :disabled='user.id !== activity.user_id',
                    @click='remove(activity.id)'
                  )
                    v-icon.icon-action delete
                v-flex
                  v-btn.ma-0.px-1.action-btn.pinned(
                    icon,
                    @click.stop='toggleEventPin',
                    v-if='activity.pinned'
                  )
                    v-icon.icon-action push_pin
                  v-btn.ma-0.action-btn.px-1(icon, @click.stop='toggleEventPin', v-else)
                    v-icon.icon-action $vuetify.icons.unpinned
      v-layout(justify-start)
        .mr-2(style='width: 35px')
        v-flex.expand-more(
          xs10
          v-if="(isExpandable(activityDescriptionByType()) && !isCmaActivity && !isCommentSection) || isContactOwnerChanged() || isSMSMobilePhoneInvalidType()"
          @click='activity.property ? getChunkedPropertyFields(activity.property[0]) : null'
        )
          v-icon.expand-icon(@click='expandDescription = !expandDescription') {{ expandDescription ? "expand_less" : "expand_more" }}
          span(
            v-if='isContactOwnerChanged()',
            style='cursor: pointer',
            @click='expandDescription = !expandDescription'
          ) {{ viewOrHideCustomFieldsOnCard(expandDescription) }}
            v-card.py-3.hide-edges(v-if='expandDescription')
              div(v-if='shouldDisplayCustomFieldsInfo()')
                div(v-for='customField in contactOwnerChangedDescription.custom_fields')
                  v-layout.ml-4(row, d-inline)
                    p.d-inline {{ customField.name }}:
                    p.d-inline.ml-2.font-weight-bold {{ customField.value }}
              div(v-else)
                p.ml-4 There are no previous data or custom fields associated with this contact.
          span(v-else, style='cursor: pointer', @click='expandDescription = !expandDescription') {{ expandDescription ? "Collapse" : "View More" }}
            v-card.py-3(:class='expandableCardClass').hide-edges(v-if='expandDescription')
              v-divider.mb-2
              .pb2.show-white-spaces(v-if='isHTML(activity.description)', v-html='safeHTML(activityDescriptionByType())')
              span.pb-2.wrap-words.show-white-spaces(
                v-else-if='!activity.property && !isHTML(activity.description)'
                v-html="safePlainText(activity.description)"
              )
              v-layout.pa-4.property-expand(
                align-center,
                justify-start,
                row,
                fill-height,
                v-if='activity.property'
              )
                v-flex(xs3, v-for='propertyField in propertyFieldColumns')
                  div(v-for='(item, key) in propertyField')
                    p.property-field.--v-secondary-lighten2 {{ item.name }}:
                      a(v-if='key === "url"', :href='item.value', target='_blank') View
                      span.property-value(v-else-if='key === "listing_price"') {{ item.value | currencyFormatter }}
                      span.property-value(v-else) {{ item.value }}
              v-divider.mt-2
        v-flex(xs, 12, v-if='isEmailActivity')
          v-btn.thread-btn(
            outline,
            small,
            color='primary',
            @click='toggleThreads = !toggleThreads'
          ) {{ activity.email_threads.length }} Threads
          .email-options.pt-2.pr-1
            span Opens: {{ activity.opens }}
            span Click: {{ activity.clicks }}
        v-flex(xs12, v-if='isEmailActivity && toggleThreads')
          activity-card(
            v-for='threads in activity.email_threads',
            :activityTypes='activityTypes',
            :activity='threads',
            :show-options='false',
            hide-card-edges
          )
          v-btn.thread-btn(
            outline,
            small,
            color='primary',
            @click='toggleThreads = !toggleThreads'
          ) Collapse Threads
            v-icon expand_less
</template>

<script>
import { formatDateMonthDayYearExtended } from '@/Core/filters/dates';
import { safePlainText, safeHTML } from '@/Core/filters/safeContent';
import { activityTypes } from '@/Contacts/config/activity-event-types';
import ActivityCard from './ActivityCard';
import { isHTML } from '@/Core/utilities/parser-string';
import { PROPERTY_FIELDS, MAX_FIELDS_PER_COLUMN } from '@/Core/config/events';
import { currencyFormatter } from '@/Core/filters/currency';
import { mapState, createNamespacedHelpers } from 'vuex';
import {
  NO_AUTH_DOMAIN_CHANNEL,
  AUTH_DOMAIN_CHANNEL,
  NYLAS_SEND_SERVICE
} from '@/Email/config/email-management';

const { mapState: mapUserInformationState, mapGetters: mapUserInformationGetters } = createNamespacedHelpers('userInformation');
const { mapState: mapDialerState, mapActions: mapDialerActions } =
  createNamespacedHelpers('dialer');

export default {
  name: 'activityCard',
  filters: {
    formatDateMonthDayYearExtended,
    safePlainText,
    currencyFormatter,
  },
  components: {
    ActivityCard,
  },
  props: {
    activity: {
      default: {},
    },
    showOptions: {
      default: true,
      type: Boolean,
    },
    hideCardEdges: {
      default: false,
      type: Boolean,
    },
    validateDescription: {
      type: Function,
    },
    updateEvent: {
      type: Function,
    },
    currentContact: {
      type: Object,
      default: () => {},
    },
    isCommentSection: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      maxDescriptionLength: 150,
      defaultIcon: 'web',
      toggleThreads: false,
      expandDescription: false,
      propertyFieldColumns: [],
      callRecordingType: 'Call Recording',
      LW_TX_ZIPFORM: 'LoneWolf Transaction zipForm',
      LW_TX_TRANSACTIONDESK: 'LoneWolf Transaction TransactionDesk',
      CONTACT_COMMENTS: 'Contact Comments',
      CONTACT_OWNER_CHANGED: 'Contact Owner Changed',
      smsNotDeliveredType: 'SMS Not Delivered',
      emailSentType: 'Email Sent',
      emailSentVia3rdPartyType: 'Email Sent via 3rd Party',
      smsNotDeliveredNoRegType: 'SMS Not Delivered - No Registration Found',
      smsNotSentType: 'SMS Not Sent',
      smsMobilePhoneInvalidType: 'SMS Invalid Mobile Number',
      qualifyTypes: [
        'Qualify Lead Created',
        'Qualify Lead Updated',
        'Qualify Rep Note',
        'Qualify User Note',
        'Qualify Lead Unclaimed',
        'Qualify Lead Claimed',
        'Qualify Rep Text Sent',
        'Qualify Lead Deleted',
        'Qualify Appointment Set',
        'Qualify Status Update',
        'Qualify Outbound SMS',
      ],
      emailNotDeliveredType: 'Email Not Delivered',
      transactionCreatedText: 'transaction created',
      contactOwnerChangedDescription: {
        description:
          'The owner has changed. Expand to review the previous custom fields set for this contact.',
        previous_owner: '',
        custom_fields: [],
      },
      CLOUD_CMA_EVENT_TYPE: 'Cloud CMA',
      cloudCMADescription: {
        address: '',
        editPdf: '',
        cmaURL: '',
        documentPDF: '',
        status: '',
      },
      copyPDFMsg: '',
      copyPDFStatus: '',
      copyPDFStatusColor: '',
    };
  },
  watch: {
    user: {
      immediate: true,
      handler(newValue) {
        if (!newValue) return;
        this.setTransactionCreatedText();
      },
    },
    activity: {
      deep: true,
      immediate: true,
      handler() {
        this.parseJSONStyleDescription();
      },
    },
  },
  computed: {
    ...mapUserInformationState(['user']),
    ...mapUserInformationGetters(['userHasFeatureFlag']),
    ...mapDialerState(['loadedRecording']),
    activityIcon() {
      const type = activityTypes.find(activity => activity.type == this.activity.type);
      return type ? type.icon : this.defaultIcon;
    },
    activityClass() {
      const activityClass = activityTypes.find(activity => activity.type == this.activity.type);
      return activityClass ? activityClass.cssClass : '';
    },
    isEmailActivity() {
      return (
        this.activity.type == 'Email Opened' &&
        this.activity.email_threads &&
        this.activity.email_threads.length
      );
    },
    isCmaActivity() {
      return this.activity.type === this.CLOUD_CMA_EVENT_TYPE;
    },
    isQualifyActivity() {
      return this.qualifyTypes.includes(this.activity.type)
    },
    isEmailSentActivity() {
      return this.activity.type === this.emailSentType || this.activity.type === this.emailSentVia3rdPartyType;
    },
    isCommentActivity() {
      return this.activity.type === this.CONTACT_COMMENTS;
    },
    cardClass() {
      if (this.isSMSNotDeliveredType() || this.isSMSMobilePhoneInvalidType() || this.isSMSNotDeliveredNoRegType() || this.isEmailNotDeliveredType() || this.isSMSNotSentType()) {
        return 'error-card';
      }
      if (this.isQualifyActivity) {
        if (this.activity.pinned) {
          return 'qualify-card border-card'
        }
        return 'qualify-card';
      }
      if (this.activity.pinned) {
        return 'border-card';
      }
      if (this.hideCardEdges) {
        return 'hide-edges';
      }
      return;
    },
    expandableCardClass() {
      if (this.isQualifyActivity) {
        return 'qualify-card';
      }
      return;
    },
    isActivityPinned() {
      if (!this.activity.pinned) return;
      return 'color: var(--v-primary-base);';
    },
    hasValidEmailSenderInfo() {
      return this.activity && this.activity.email_sender && this.activity.email_channel && this.activity.user_email
    },
    sentFromDetail() {
      if (!this.isEmailSentActivity || !this.hasValidEmailSenderInfo) {
        return ''
      }
      if (this.activity.email_sender === NYLAS_SEND_SERVICE) {
        return 'Sent from connected account'
      }
      switch (this.activity.email_channel) {
        case AUTH_DOMAIN_CHANNEL:
          return 'Sent from authenticated domain';
        case NO_AUTH_DOMAIN_CHANNEL:
          return 'Sent from non-authenticated domain';
        default:
          return 'Sent from complimentary email';
      }
    }
  },
  methods: {
    ...mapDialerActions(['getRecording']),
    safePlainText,
    isExpandable(description) {
      return (
        this.safePlainText(description, this.maxDescriptionLength).length >
          this.maxDescriptionLength || this.activity.property || (this.isCommentActivity && this.isHTML(description))
      );
    },
    toggleEventPin() {
      this.$emit('activity-pinned', this.activity);
    },
    remove(activityId) {
      this.$emit('activity-deleted', activityId);
    },
    refreshEvents() {
      this.$emit('activity-updated');
    },
    isApiEvent(activity) {
      return activity.source === 'api' && activity.property;
    },
    activityTitleUserName() {
      if (this.isContactOwnerChanged()) {
        return this.contactOwnerChangedDescription.previous_owner;
      }
      return `${this.activity.user.first_name} ${this.activity.user.last_name}`;
    },
    isContactOwnerChanged() {
      return this.activity.type === this.CONTACT_OWNER_CHANGED;
    },
    getChunkedPropertyFields(fields = null) {
      this.propertyFieldColumns = [];
      let orderedFields = {};
      let counter = 0;
      Object.keys(PROPERTY_FIELDS).forEach(key => {
        if (counter === MAX_FIELDS_PER_COLUMN) {
          this.propertyFieldColumns.push(orderedFields);
          orderedFields = {};
          counter = 0;
        }
        orderedFields[key] = {
          name: PROPERTY_FIELDS[key],
          value: fields[key],
        };
        counter++;
      });
      this.propertyFieldColumns.push(orderedFields);
    },
    safeHTML,
    isHTML,
    isRecordingLoaded(recordingId) {
      if (!this.loadedRecording) return false;
      return this.loadedRecording.recordingId === recordingId;
    },
    isSMSNotDeliveredType() {
      return this.activity.type === this.smsNotDeliveredType;
    },
    isSMSNotDeliveredNoRegType() {
      return this.activity.type === this.smsNotDeliveredNoRegType;
    },
    isSMSNotSentType() {
      return this.activity.type === this.smsNotSentType;
    },
    isSMSMobilePhoneInvalidType() {
      return this.activity.type === this.smsMobilePhoneInvalidType;
    },
    isEmailNotDeliveredType() {
      return this.activity.type === this.emailNotDeliveredType;
    },
    activityTitle() {
      if (this.activity.type !== this.smsNotDeliveredType) return this.activity.type;
      return 'Text Sent [Undelivered]';
    },
    parseJSONStyleDescription() {
      if (
        this.activity.type !== this.CLOUD_CMA_EVENT_TYPE &&
        this.activity.type !== this.CONTACT_OWNER_CHANGED
      )
        return;

      let rawDescription = this.activity.description;
      if (
        this.activity.description.includes('&#34;') ||
        this.activity.description.includes('&quot;')
      ) {
        // Regex to replace &quot; or &#34; for double quotes
        rawDescription = this.activity.description.replaceAll(/\&(quot;|#34;)/gi, '"');
      }

      if (this.activity.type === this.CLOUD_CMA_EVENT_TYPE) {
        this.cloudCMADescription = JSON.parse(rawDescription);
      }

      if (this.activity.type === this.CONTACT_OWNER_CHANGED) {
        this.contactOwnerChangedDescription = JSON.parse(rawDescription);
      }
    },
    setTransactionCreatedText() {
      this.transactionCreatedText = `${this.user.first_name} ${this.user.last_name} transaction created`;
    },
    isLoneWolfTransaction() {
      return (
        this.activity.type === this.LW_TX_ZIPFORM ||
        this.activity.type === this.LW_TX_TRANSACTIONDESK
      );
    },
    checkActivityPropertyAndType() {
      const types = [
        this.callRecordingType,
        this.CLOUD_CMA_EVENT_TYPE,
        this.LW_TX_ZIPFORM,
        this.LW_TX_TRANSACTIONDESK,
        this.CONTACT_OWNER_CHANGED,
      ];
      return (!this.activity.property && !types.includes(this.activity.type)) && !this.isCommentSection;
    },
    checkCloudCMAStatus(value) {
      return this.cloudCMADescription.status === value;
    },
    viewOrHideCustomFieldsOnCard(value) {
      const text = `${this.user.first_name} ${this.user.last_name} custom fields`;
      return value ? `Hide ${text}` : `View ${text}`;
    },
    shouldDisplayCustomFieldsInfo() {
      const customFieldsValues = this.contactOwnerChangedDescription.custom_fields.filter(c => c.value);
      return (this.contactOwnerChangedDescription.custom_fields.length && customFieldsValues.length);
    },
    copyPdfURL() {
      navigator.clipboard
        .writeText(this.cloudCMADescription.documentPDF)
        .then(() => {
          this.copyPDFStatus = true;
          this.copyPDFMsg = 'PDF URL copied to clipboard.';
          this.copyPDFStatusColor = 'success';
        })
        .catch(err => {
          this.copyPDFStatus = err;
          this.copyPDFMsg = 'Error copying URL to clipboard.';
          this.copyPDFStatusColor = 'error';
        });
    },
    userHasCustomFieldsSharingFF() {
      if (this.activity.type === this.CONTACT_OWNER_CHANGED && !this.userHasFeatureFlag('custom-fields-sharing')) return false;
      return true;
    },
    activitySubtitleByType() {
      if (this.isQualifyActivity) {
        return safeHTML(this.getElementByClass(this.activity.description, "qualify-content-subtitle"));
      }
      if (this.isSMSNotDeliveredNoRegType()) {
        return safeHTML(this.getElementByClass(this.activity.description, "no-reg-card-subtitle"));
      }
      if (this.isSMSNotSentType()) {
        return safeHTML(this.getElementByClass(this.activity.description, "not-sent-card-subtitle"));
      }
      return;
    },
    activityDescriptionByType() {
      if (this.isQualifyActivity) {
        return this.getElementByClass(this.activity.description, "qualify-content-body");
      }

      if (this.isSMSNotDeliveredNoRegType()) {
        return safeHTML(this.getElementByClass(this.activity.description, "no-reg-card-body"));
      }

      if (this.isSMSNotSentType()) {
        return safeHTML(this.getElementByClass(this.activity.description, "not-sent-card-body"));
      }

      if (this.isSMSMobilePhoneInvalidType()) { return '' }

      return this.activity.description;
    },
    getElementByClass(htmlContent, className) {
      var wrapper = document.createElement("div");
      wrapper.innerHTML = htmlContent;
      try {
        return wrapper.getElementsByClassName(className)[0].outerHTML;
      }
      catch (error) { return "<div></div>" }
    },
    editEvent(event) {
      let edit = {
        contactId: event.contact_id,
        id: event.id,
        type: event.type,
        description: event.description
      }
      this.$emit('edit-event', edit);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../Core/assets/scss/main.scss';

.tooltipBody {
  max-width: 200px;
}

.activity-title {
  font-weight: bold;
  font-size: 13px;
  margin-right: 4px;
  cursor: default !important;
}

.email-options {
  float: right;
  opacity: 0.6;
  font-size: 12px;
}

/deep/ .qualify-content-subtitle {
  font-size: 11px;
  margin-right: 4px;
}

/deep/ .qualify-content-hidden {
  display: none;
}

/deep/ .no-reg-card-subtitle {
  color: red;
}

.date {
  float: right;
  opacity: 0.6;
}

.icon-container {
  .actions  {
    font-size: 18px;
    width: 16px;
    padding: 3px;
  }
  .icon {
    border-radius: 30px;
    color: #ffffff !important;
    height: 35px;
    width: 35px;
    font-size: 18px;
    background-color: var(--v-primary-base);
    &.email {
      background-color: $mail-icon;
    }
    &.texts {
      background-color: $text-icon;
    }
    &.call {
      background-color: $call-icon;
    }
    &.comment {
      background-color: $comment-icon;
    }
    &.visit {
      background-color: $visit-icon;
    }
    &.lead {
      background-color: $lead-icon;
    }
    &.loneWolfTransaction {
      background-color: transparent;
      transform: scale(1.1);
    }
    &.smsNotDelivered {
      background-color: $lion-sms-error;
    }
    &.cloudCMA {
      background-color: #20b575;
      padding: 8px;
    }
    &.ownerChanged {
      background-color: var(--v-primaryv2-base);
    }
  }
}

.border-card {
  border: 2px solid #20779c;
  border-radius: 4px;
}

.error-card {
  border: 1px solid $lion-sms-error;
  border-radius: 4px;
}

.expand-more {
  text-align: center;
  font-size: 12px;
  color: var(--v-primary-base);
  width: 100%;
}

.expand-icon {
  font-size: 18px;
  color: var(--v-primary-base);
  cursor: pointer;
}

.text-style,
.date {
  font-size: 12px;
  letter-spacing: 0.5px;
}

.hide-edges {
  box-shadow: 0px 0px;
  text-align: left;
}

//Ask about color variable
.qualify-card {
  background-color: #DEE1E9;
}

.action-btn {
  width: 25px;
  height: 25px;
  opacity: 0.5;
}

.icon-action {
  font-size: 15px;
  width: 15px;
}

.thread-btn {
  text-transform: capitalize;
  font-weight: initial;
  font-size: inherit;
}

.expanded-description {
  width: 80%;
}

.pinned {
  color: var(--v-primary-base);
  opacity: 1;
}

.wrap-words {
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  hyphens: auto;
}

.property-value {
  font-weight: 400;
  margin-bottom: 2px;
}

.property-field {
  font-weight: 600;
  margin-bottom: 1px;
  color: var(--v-secondary-lighten2);
}

.play-recording {
  height: 25px;
  width: 25px;
}

.open-link-icon {
  font-size: 16px;
}

.show-white-spaces {
  white-space: pre-wrap;
}

/deep/ .event-attachments{
  padding: 5px 0px;
  margin: 5px 5px 0px 5px;
  border-top: 1px solid rgba(0, 0, 0, 0.87);
  &::before {
    content: 'Attachments:';
    display: block;
  }
  a {
    display: inline-block;
    padding: 2px 5px;
    border-radius: 10px;
    background-color: #e0e0e0;
    color: #000;
    margin-top: 2px;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }
}

.email-sent-info-menu {
    border-radius: 10px !important;
}
</style>

